import { UserLogInResponse } from './../Generated/orval-apis/cit.schemas';
import Axios from 'axios';
import { ApiUtility, IApiResponse } from '../Utilities/ApiUtility.axios';
import { resetAllReduxStates, Utils } from '../Utilities/Utils';
import { message } from 'antd';
import { store } from '../Store/store';
import { setUserData, userData } from '../Store/Slice/userSlice';
import HTTPSCalls from './HTTPCalls';
import { broadcastLogin, broadcastLogout } from '../Utilities/AuthBroadcast';
import { RoleTypes } from '../Generated/orval-apis/cit.schemas';
import { setDepartment } from '../Store/Slice/departmentSlice';

export interface IUserLoginResponse {
  id:string;
  name?: string;
  token: string;
  tokenExpiry: number;
  requiresTwoFactor:boolean;
  twoFactorSuccess:boolean;
}

export const AuthService = {
  login: async (username: string, password: string): Promise<UserLogInResponse | null> => {
    //console.log(process.env.REACT_APP_API_BASE_URL)
    const response = await Axios.post<IApiResponse<UserLogInResponse>>(
      //`${process.env.REACT_APP_API_BASE_URL}/Auth/Login`,
      `Auth/Login`,
      { username, password } as any,
      ApiUtility._axiosOptions({ withCredentials: true })
    );
    if (response.status === 200) {
      if (response.data && response.data.status) {
        const { result } = response.data;
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        // InMemoryJWT.setToken(result.token, result.tokenExpiry);
        // Utils.setLocal('tp-user', result);
      if (result?.requiresTwoFactor) {
        // store.dispatch(setUserData(result));
        // message.info("Two-factor authentication required. Please verify your code.");
        // window.location.href = "/verify-2fa"; 
        console.log("in login",result);
        return result;
      }
        store.dispatch(setUserData(result));
        broadcastLogin();
        // Utils.setSession('tp-user', result);
        const user = userData(store.getState());

        if (user?.roleType === RoleTypes.SuperAdmin) return null;

        if (user?.roleType !== RoleTypes.Student) {
          if (user?.departments != undefined && user?.departments?.length > 0) {
            store.dispatch(setDepartment(user?.departments[0].id));
          } else {
            message.warning("No department assigned to this user.");
          }
        }
        return response.data.result;
      } else message.error(response?.data?.message || "Something went Wrong.");
    } else message.error(response?.data?.message || "Something went Wrong.");
    return null;
  },

  loginAs: async (pid: string, id: string) => {
    const response = await Axios.post<IApiResponse<IUserLoginResponse>>(
      '/auth/' + pid + '/loginas/' + id,
      {} as any,
      ApiUtility._axiosOptions({
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        withCredentials: true,
      })
    );
    if (response.status === 200) {
      if (response.data && response.data.status) {
        const { result } = response.data;
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        // InMemoryJWT.setToken(result.token, result.tokenExpiry);

        return response.data.result;
      } else if (response.data && response.data.message) throw message.error(response.data.message);

      return null;
    }
  },


  forgotPassword: async (email: string) => {
    const response = await Axios.post<IApiResponse>(
      `${process.env.REACT_APP_API_BASE_URL}/Auth/ForgotPassword`,
      { email },
      ApiUtility._axiosOptions()
    );
    if (response.status === 200) {
      if (response.data && response.data.status) {
        return response.data;
      } else if (response.data && response.data.message) {
        return response.data;
      }
    }
  },

  resetPassword: async (
    userId: string | undefined,
    password: string,
    confirmpassword: string,
    code: string | undefined
  ) => {
    const response = await Axios.post<IApiResponse>(
      `${process.env.REACT_APP_API_BASE_URL}/Auth/ResetPassword`,
      { userId, password, confirmpassword, code },
      ApiUtility._axiosOptions()
    );
    if (response.status === 200) {
      if (response.data && response.data.status) {
        return response.data;
      } else if (response.data && response.data.message) {
        return response.data;
      }
    }
  },

  logout: async () => {
    try {
      await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.LOGOUT,{},{});
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    } finally{
      resetAllReduxStates();
      broadcastLogout();
    }
  },

  // getAuthToken: (): string | null =>
  //   InMemoryJWT.getToken() || Utils.getLocal(LocalStorageKeyToken),
    getAuthToken: (): string | null => {
    const token = Utils.getTokenFromRedux();
    return token || null;
  },

  isAuthenticated: (): boolean => AuthService.getAuthToken() !== null,

  userRole() {
    if (AuthService.getAuthToken() != null) {
      // let user = Utils.getLocal('tp-user');
      const user=store.getState().user;
      return user?.role || null;
    }
  },

};

export const Roles = {
  SuperAdmin: 'SUPERADMIN',
  Admin: 'ADMIN',
  HrManager: 'HRMANAGER',
  HrExecutive: 'HREXECUTIVE',
  Employee: 'EMPLOYEE',
  Candidate: 'CANDIDATE',
  TeamLeader: 'TEAMLEADER',
  Interviewer: 'INTERVIEWER',
};
